import React from "react";

const Contact = () => {
    return (
        <div
            className="flex justify-center items-center min-h-screen bg-center bg-no-repeat text-white">
      <div className="bg-black/30 rounded-xl shadow-lg max-w-md w-full p-6 text-center">
                <h1 className="text-4xl font-bold uppercase tracking-wide mb-6">Contact Us</h1>
                <div className="space-y-4 text-lg">
                    <p>
                        For App Questions:{" "}
                        <a
                            href="mailto:support@ananas.site"
                            className="text-blue-400 hover:underline"
                        >
                            support@ananas.site
                        </a>
                    </p>
                    <p>
                        For General Inquiries:{" "}
                        <a
                            href="mailto:info@ananas.site"
                            className="text-blue-400 hover:underline"
                        >
                            info@ananas.site
                        </a>
                    </p>
                    <p>
                        For Privacy Concerns:{" "}
                        <a
                            href="mailto:privacy@ananas.site"
                            className="text-blue-400 hover:underline"
                        >
                            privacy@ananas.site
                        </a>
                    </p>
                    <p>
                        For Feedback:{" "}
                        <a
                            href="mailto:feedback@ananas.site"
                            className="text-blue-400 hover:underline"
                        >
                            feedback@ananas.site
                        </a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Contact;
